import Vue from 'vue'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

// Cookie que a borda (CDN/proxy) usa para escolher o bundle: monolito, beta ou hml
const COOKIE_VERSAO = 'versao_app'
// Troca manual via ?versao_app=: enquanto existir, vence o valor do banco
const COOKIE_FORCADA = 'versao_app_forcada'
// Cookie da implementação anterior (versao|base + confirmação); só é apagado
const COOKIE_LEGADO_CONFIRMADA = 'versao_app_forcada_confirmada'
const VERSOES_VALIDAS = ['monolito', 'beta', 'hml']
const EXPIRACAO_VERSAO = '30d'
const EXPIRACAO_FORCADA = '7d'

// Regra única: alvo = versao_app_forcada (se existir) senão o valor do banco
// (header x-versao-app). Se o cookie versao_app for diferente do alvo, a troca
// fica pendente e é aplicada na navegação de rota (nunca no meio de uma tela).
//
// O override manual vale até expirar (7 dias) ou até ?versao_app=auto. Mudança
// no banco (Areadev) NÃO derruba o override: a implementação anterior tentava
// detectar isso guardando base e confirmação em mais dois cookies e a versão
// "voltava do nada" (2026-09-14/17).

let versaoPendente = null

const normaliza = (versao) => {
    if (!versao) {
        return null
    }
    // Bundles antigos gravavam 'versao|base' no cookie de override: vale o primeiro segmento
    const limpa = String(versao).split('|')[0]
    return VERSOES_VALIDAS.includes(limpa) ? limpa : null
}

export const pegaVersaoAppForcada = () => normaliza(Vue.$cookies.get(COOKIE_FORCADA))

const gravaVersao = (versao) => {
    Vue.$cookies.set(COOKIE_VERSAO, versao, EXPIRACAO_VERSAO)
}

const removeOverride = () => {
    Vue.$cookies.remove(COOKIE_FORCADA)
    Vue.$cookies.remove(COOKIE_LEGADO_CONFIRMADA)
}

// ?versao_app=hml|beta|monolito grava o override e o cookie da borda e recarrega;
// ?versao_app=auto remove o override (o banco volta a valer na próxima resposta da API)
export const aplicaVersaoAppDaUrl = () => {
    if (Vue.$cookies.isKey(COOKIE_LEGADO_CONFIRMADA)) {
        Vue.$cookies.remove(COOKIE_LEGADO_CONFIRMADA)
    }
    const url = new URL(window.location.href)
    const parametro = url.searchParams.get(COOKIE_VERSAO)
    if (parametro === null) {
        return false
    }
    url.searchParams.delete(COOKIE_VERSAO)
    window.history.replaceState(null, '', url.pathname + url.search + url.hash)
    if (parametro === 'auto') {
        removeOverride()
        window.location.reload()
        return true
    }
    const versao = normaliza(parametro)
    if (!versao) {
        return false
    }
    Vue.$cookies.set(COOKIE_FORCADA, versao, EXPIRACAO_FORCADA)
    gravaVersao(versao)
    window.location.reload()
    return true
}

// Interceptor de resposta do $api: decide o alvo e marca a troca pendente
export const processaVersaoAppResposta = (headers) => {
    const versaoBanco = normaliza(headers && headers['x-versao-app'])
    if (!versaoBanco) {
        return
    }
    const alvo = pegaVersaoAppForcada() || versaoBanco
    versaoPendente = alvo !== Vue.$cookies.get(COOKIE_VERSAO) ? alvo : null
}

// Aplica a troca pendente: grava o cookie da borda e recarrega na rota destino
// (destinoHref já resolvido pelo router, respeitando a base do build)
export const aplicaVersaoAppPendente = (destinoHref) => {
    if (!versaoPendente) {
        return false
    }
    gravaVersao(versaoPendente)
    versaoPendente = null
    window.location.href = destinoHref
    return true
}
